(function () {
  var popup = document.getElementById('ProductCreatorPopup');
  if (!popup) return;

  var productForm = document.querySelector('.ProductForm');
  var pageOverlay = document.querySelector('.PageOverlay');
  var errorEl = popup.querySelector('[data-creator-error]');
  var addDefaultBtn = popup.querySelector('[data-action="confirm-creator-add-to-cart"]');
  var addBundleBtn = popup.querySelector('[data-action="confirm-creator-add-bundle"]');
  var mainImageEl = popup.querySelector('[data-creator-main-image]');
  var mainPriceEl = popup.querySelector('[data-creator-main-price]');
  var mainVariantEl = popup.querySelector('[data-creator-main-variant]');
  var headingEl = popup.querySelector('.ProductCreator__Heading');
  var descriptionEl = popup.querySelector('[data-creator-description]');
  var selectedVariantIds = new Set();

  // The block settings (heading override, description) live on the "Complete your set" block,
  // which isn't reachable from here — this popup renders from layout/theme.liquid, not from
  // inside the section — so complete-your-set.liquid bridges them across via this JSON payload.
  function applyDrawerContent() {
    var dataEl = document.querySelector('[data-creator-drawer-content]');
    if (!dataEl) return;

    var content;
    try {
      content = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    if (headingEl && content.heading) headingEl.textContent = content.heading;

    if (descriptionEl && content.description) {
      descriptionEl.innerHTML = content.description;
      descriptionEl.hidden = false;
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape') closePopup();
  }

  // The popup's main-product preview is rendered from the initially selected variant. If the
  // customer changes variant/size after page load and before clicking add-to-cart, refresh the
  // preview from the same [data-product-json] payload theme.js's ProductVariants already reads.
  function syncMainProduct() {
    if (!productForm) return;

    var dataEl = productForm.querySelector('[data-product-json]');
    var idInput = productForm.querySelector('[name="id"]');
    if (!dataEl || !idInput) return;

    var payload;
    try {
      payload = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    var variant = (payload.product.variants || []).find(function (v) {
      return String(v.id) === String(idInput.value);
    });
    if (!variant) return;

    if (mainImageEl) {
      var image = variant.featured_image || payload.product.featured_image;
      if (image && image.src) mainImageEl.src = image.src.split('?')[0] + '?width=200';
    }

    if (mainPriceEl && window.Currency && window.theme) {
      mainPriceEl.textContent = window.Currency.formatMoney(variant.price, window.theme.moneyWithCurrencyFormat);
    }

    if (mainVariantEl) {
      mainVariantEl.textContent = variant.title;
      mainVariantEl.hidden = variant.title === 'Default Title';
    }
  }

  function openPopup() {
    syncMainProduct();
    popup.setAttribute('aria-hidden', 'false');
    if (pageOverlay) {
      pageOverlay.classList.add('is-visible');
      pageOverlay.addEventListener('click', closePopup);
    }
    document.documentElement.classList.add('no-scroll');
    document.addEventListener('keydown', onKeydown);
  }

  function closePopup() {
    popup.setAttribute('aria-hidden', 'true');
    if (pageOverlay) {
      pageOverlay.classList.remove('is-visible');
      pageOverlay.removeEventListener('click', closePopup);
    }
    document.documentElement.classList.remove('no-scroll');
    document.removeEventListener('keydown', onKeydown);
  }

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message || '';
    errorEl.hidden = !message;
  }

  // Swaps the theme's own button variants rather than overriding colors ourselves (see the
  // matching note on the card toggles below) so the footer buttons pick up the theme's
  // Button--primary/Button--secondary looks: dark/white-text by default, flipped to
  // white/dark-text once at least one extra item is selected.
  function updateBundleButtonState() {
    var hasSelection = selectedVariantIds.size > 0;
    if (addBundleBtn) addBundleBtn.setAttribute('aria-disabled', String(!hasSelection));

    if (addDefaultBtn) {
      addDefaultBtn.classList.toggle('Button--primary', !hasSelection);
      addDefaultBtn.classList.toggle('Button--secondary', hasSelection);
    }
    if (addBundleBtn) {
      addBundleBtn.classList.toggle('Button--secondary', !hasSelection);
      addBundleBtn.classList.toggle('Button--primary', hasSelection);
    }
  }

  function resetSelection() {
    selectedVariantIds.clear();
    popup.querySelectorAll('[data-action="toggle-creator-item"]').forEach(function (button) {
      button.setAttribute('aria-pressed', 'false');
      button.classList.add('Button--primary');
      button.classList.remove('Button--secondary');
    });
    updateBundleButtonState();
  }

  function publishAddToCartAnalytics() {
    if (!window.Shopify || typeof window.Shopify.analytics?.publish !== 'function') return;

    var dataEl = document.querySelector('[data-creator-analytics]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    window.Shopify.analytics.publish('product_added_to_cart', {
      ecommerce: {
        items: [
          {
            item_id: String(data.id),
            item_name: data.title,
            item_brand: data.vendor,
            item_category: data.category,
            item_variant: data.sku,
            currency: data.currency,
            price: data.price,
          },
        ],
      },
    });
  }

  function addToCart(includeExtras, triggerBtn) {
    if (!productForm || triggerBtn.getAttribute('aria-disabled') === 'true') return;

    var idInput = productForm.querySelector('[name="id"]');
    var quantityInput = productForm.querySelector('[name="quantity"]');
    var mainVariantId = idInput && idInput.value;

    if (!mainVariantId) return;

    var mainQuantity = (quantityInput && parseInt(quantityInput.value, 10)) || 1;
    var items = [{ id: mainVariantId, quantity: mainQuantity }];

    if (includeExtras && selectedVariantIds.size > 0) {
      var setId = '#' + Math.random().toString(36).substring(2, 9);
      items[0].properties = { _setId: setId };
      selectedVariantIds.forEach(function (variantId) {
        items.push({ id: variantId, quantity: 1, properties: { _setId: setId } });
      });
    }

    showError('');
    addDefaultBtn.setAttribute('aria-disabled', 'true');
    if (addBundleBtn) addBundleBtn.setAttribute('aria-disabled', 'true');
    triggerBtn.classList.add('is-loading');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function () {
        var addedQuantity = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);

        publishAddToCartAnalytics();
        document.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: { quantity: addedQuantity },
          })
        );

        // CartSection's own "product:added" handler re-renders the mini-cart drawer, but (per
        // the existing quick-add flow in custom.js) it does not patch the header icon badge itself.
        var cartCountEl = document.querySelector('span.Cart__Count');
        if (cartCountEl) {
          var count = (parseInt(cartCountEl.innerHTML.replace(/[^\d]/g, ''), 10) || 0) + addedQuantity;
          cartCountEl.innerHTML = '(' + count + ')';
        }

        resetSelection();
        closePopup();
      })
      .catch(function (error) {
        showError((error && error.description) || 'Wystąpił błąd. Spróbuj ponownie.');
      })
      .finally(function () {
        addDefaultBtn.removeAttribute('aria-disabled');
        updateBundleButtonState();
        triggerBtn.classList.remove('is-loading');
      });
  }

  // Intercept the main add-to-cart click during the capture phase, before the delegated
  // bubble-phase listener bound by theme.js's ProductVariants._addToCart ever sees it.
  document.addEventListener(
    'click',
    function (event) {
      if (!productForm) return;
      var trigger = event.target.closest('[data-action="add-to-cart"]');
      if (!trigger || !productForm.contains(trigger)) return;

      event.preventDefault();
      event.stopPropagation();
      openPopup();
    },
    true
  );

  popup.addEventListener('click', function (event) {
    if (event.target.closest('[data-action="close-creator-popup"]')) {
      closePopup();
      return;
    }

    var toggle = event.target.closest('[data-action="toggle-creator-item"]');
    if (toggle) {
      var isPressed = toggle.getAttribute('aria-pressed') === 'true';
      var variantId = toggle.getAttribute('data-variant-id');
      toggle.setAttribute('aria-pressed', String(!isPressed));
      // Swap the theme's own button variants rather than overriding colors ourselves — Button--primary's
      // visible background is painted by a ::before layer, so a plain background/border override on the
      // button itself wouldn't reliably show through it.
      toggle.classList.toggle('Button--primary', isPressed);
      toggle.classList.toggle('Button--secondary', !isPressed);
      if (isPressed) {
        selectedVariantIds.delete(variantId);
      } else {
        selectedVariantIds.add(variantId);
      }
      updateBundleButtonState();
      return;
    }

    if (event.target.closest('[data-action="confirm-creator-add-to-cart"]')) {
      addToCart(false, addDefaultBtn);
      return;
    }

    if (event.target.closest('[data-action="confirm-creator-add-bundle"]')) {
      addToCart(true, addBundleBtn);
    }
  });

  applyDrawerContent();
})();
